import styled from "styled-components";
import {
  SPIN_BONUS_IMG,
  BONUS_IMG,
  RefreshOutlined,
  WALLET_BG_IMG
} from "@assets";
import {
  REJECTED_SK,
  REQUESTED_SK,
} from '@constants';

export const RootContainer = styled.div`
position: relative;
height: 100vh;
overflow: hidden;
`;

export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const TopContainer = styled.div`
position: relative;
`;

export const BackgroundImage = styled.img.attrs({
  alt: 'bgimg',
  src: WALLET_BG_IMG,
})`
width: 100%;
height: 216px;
position: absolute;
top: 0;
left: 0;
z-index: 1;
`;

export const TopWrapper = styled.div`
width: 100%;
padding: 16px 0;
z-index: 2;
position: relative;
display: inline-flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 12px;
text-align: center;
`;

export const TopTitle = styled.div`
padding: 3px 15px;
border-radius: 18px;
background-color: #6D1304;

font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #fff;
`;

export const BalanceText = styled.div`
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #F5D016;
`;

export const LightText = styled.span`
font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #F7F7F7;
`;

export const LightTextLabel = styled(LightText)`
color: #E1A59C;
`;

export const LabelWrapper = styled.div`
display: flex;
gap: 4px;
justify-content: center;
align-items: center;

.ant-badge .ant-badge-status-dot {
    width: 4px;
    height: 4px;
    line-height: 1;
    background: #F5D016 !important;
}
`;

export const ActionButton = styled.div`
flex: 1;
padding: 14px;
display: flex;
justify-content: center;
align-items: center;
gap: 4px;

background-color: ${props => props.theme.buttonColor};
border-radius: 27px;
cursor: pointer;
`;

export const ActionLabel = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #F7F7F7;
`;

export const ActionsWrapper = styled.div`
width: 100%;
margin-top: 8px;
display: flex;
gap: 16px;
align-items: center;
justify-content: center;

>div {
    :first-child {
        margin-inline-start: 16px;
    }
    :last-child {
        margin-inline-end: 16px;
    }
}
`;

export const BottomBar = styled.div`
width: 100%;
height: 70px;
position: absolute;
bottom: 0;
display: flex;
align-items: center;
justify-content: center;

background: ${props => props.theme.navbarColor};
text-align: center;
cursor: pointer;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #fff;
`;

export const ListTitle = styled.div`
padding: 16px;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #101415;
text-align: center;
`;

export const EmptyText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;

export const ListContainer = styled.div`
height: calc(100vh - 418px);
overflow-y: auto;

.loader {
    height: calc(100vh - 406px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-box {
    height: calc(100vh - 406px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 16px;
  margin-bottom: 1px;
  background-color: #F7F7F7;
  display: flex;
  align-items: center;
  gap: 12px;
  @media screen and (max-width: 350px) {
    padding: 6px;
    grid: 6px;
  }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 5px;
`

export const ItemImage = styled.img.attrs({
  alt: 'img'
})`
width: 55px;
height: 55px;
border-radius: 8px;
object-fit: cover;

@media screen and (max-width: 350px) {
width: 38px;
height: 38px;
}
`;

export const InfoWrapper = styled.div`
flex: 1;
display: flex;
width: 100%;

> :nth-child(1) {
  flex: 1;
}
`;

export const Wrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
/* grid-gap: 8px; */
`;

export const ItemText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
text-transform: capitalize;
color: #101415;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #808080;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const AmountText = styled.div`
white-space: nowrap;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #C21C05;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
height: 100%;
white-space: nowrap;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
text-transform: capitalize;
color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#101415"
      : props.status === REJECTED_SK
        ? "#C21C05"
        : "#1F960C"};
background-color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#F5D016"
      : props.status === REJECTED_SK
        ? "#F0D2CD"
        : "#D3FEB2"};
border-radius: 27px;
padding: 0 8px;
display: flex;
align-items: center;
justify-content: center;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const BonusStatusText = styled(StatusText)`
text-transform: none;
width: auto;
color: ${(props) => props.status === 'Used' ? "#C21C05" : "#1F960C"};
background-color: ${(props) => props.status === 'Used' ? "#F0D2CD" : "#D3FEB2"};
`;

export const ImageWrapper = styled.div`
width: 39px;
height: 39px;
border-radius: 8px;
object-fit: cover;
background-color: #D4D6D6;
display: flex;
align-items: center;
justify-content: center;
padding: 8px;

@media screen and (max-width: 350px) {
width: 26px;
height: 26px;
padding: 6px;
}
`;

const Image = styled.img.attrs({
  alt: "img",
})`
width: 100%;
object-fit: contain;
align-self: center;
`;

export const SpinImage = styled(Image).attrs({
  src: SPIN_BONUS_IMG,
})``;

export const BonusImage = styled(Image).attrs({
  src: BONUS_IMG,
})``;

export const ExpiredLabel = styled.span`
white-space: nowrap;
color: #C21C05;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;

@media screen and (max-width: 365px) {
    font-size: 11px;
  }
`;

export const ExpiredText = styled(ExpiredLabel)`
color: #808080;
`;